import { useDialog, useMobileMenu } from "@platform/store";
import { useUserMeetings } from "@platform/hooks/useUserMeetings";
import { ProgramMeetingInformationDialog } from "./ProgramMeetingInformationDialog";

type MeetingInformationDialogProps = {
  meetingId?: number;
};

export function ProgramMeetingInformationContainer() {
  const { activeDialog, dialogProps, closeDialog } = useDialog();
  const { close: closeMobileMenu } = useMobileMenu();

  const isOpen = activeDialog === "meetingInformation";

  const meetingId = (dialogProps as MeetingInformationDialogProps | undefined)
    ?.meetingId;

  const { meetings, isLoading } = useUserMeetings();
  const meeting = meetings.find((m) => m.id === meetingId);
  const participants = meeting?.participants;

  const handleDone = () => {
    closeDialog();
    closeMobileMenu();
  };

  return (
    <ProgramMeetingInformationDialog
      participants={participants}
      isLoading={isLoading}
      onClose={handleDone}
      isOpen={isOpen}
    />
  );
}

export default ProgramMeetingInformationContainer;
